// Mock data for Uswa Nasir's Portfolio
// All data here will be moved to backend during integration phase

export const profile = {
  name: "Uswa Nasir",
  role: "Full Stack Software Engineer",
  tagline: "I build web apps that actually work. Fast, clean, and without drama.",
  location: "Remote · Turku · Finland",
  yearsExperience: 3,
  rolesShipped: 5,
  perfGains: "30%",
  phone: "+1 (555) 010-2034",
  resumeUrl: "#",
  socials: {
    github: "https://github.com/UswaNasir1",
    linkedin: "https://linkedin.com/in/uswa-nasir"
  }
};

export const aboutText = {
  eyebrow: "Background",
  paragraphs: [
    "I'm a full-stack engineer with 3+ years of experience building scalable web applications, optimizing backend systems, and shipping production-ready solutions.",
    "I've worked across frontend, backend, and DevOps, building everything from dynamic user interfaces to robust APIs and automated infrastructure.",
    "Currently, I focus on creating systems that are not just functional, but efficient, maintainable, and thoughtfully designed."
  ],
  pillars: [
    {
      title: "Systems Thinking",
      desc: "I design architectures that scale cleanly and evolve without breaking.",
      icon: "Network"
    },
    {
      title: "Performance First",
      desc: "I optimize aggressively, reducing latency and improving UX.",
      icon: "Gauge"
    },
    {
      title: "End-to-End Ownership",
      desc: "From UI to infra, I build and ship complete production systems.",
      icon: "Workflow"
    }
  ]
};

// Skills as chip clusters per category - 6 categories, real stack from uswanasir.com
export const skills = [
  {
    category: "Frontend",
    code: "~/frontend",
    icon: "Layout",
    items: ["ReactJS", "JavaScript", "HTML", "CSS", "Material UI", "JavaFX", "Bootstrap"]
  },
  {
    category: "Backend",
    code: "~/backend",
    icon: "Server",
    items: ["NodeJS", "ExpressJS", "GraphQL", "REST APIs", "PostgreSQL", "MySQL"]
  },
  {
    category: "DevOps & Cloud",
    code: "~/devops",
    icon: "Cloud",
    items: ["Docker", "Kubernetes", "Helm", "Terraform", "Azure", "CI/CD", "Git"]
  },
  {
    category: "Languages",
    code: "~/languages",
    icon: "Code2",
    items: ["JavaScript", "TypeScript", "Python", "Java", "PHP", "C/C++"]
  },
  {
    category: "Tools",
    code: "~/tools",
    icon: "Wrench",
    items: ["GitHub", "Cypress", "JUnit", "VS Code", "Postman"]
  },
  {
    category: "AI Tools",
    code: "~/ai",
    icon: "Sparkles",
    items: ["GitHub Copilot", "OpenAI APIs", "Claude", "Cursor", "LangChain"]
  }
];

export const experience = [
  {
    id: "exp-1",
    period: "Current",
    role: "Software Engineer",
    company: "Zones LLC",
    location: "United States, Remote",
    bullets: [
      { text: "Contributed to architecture design by defining service boundaries and API contracts, reducing cross-service dependencies and improving delivery speed by", metric: "~15%" },
      { text: "Optimized backend systems using NodeJS and GraphQL, added Redis caching, reducing API latency by", metric: "25–35%" },
      { text: "Improved ReactJS frontend performance by reducing bundle size and modernizing components, improving load times by", metric: "30%" },
      { text: "Implemented DevOps pipelines using Docker, Kubernetes, Helm, improving deployment reliability and reducing CI/CD issues", metric: null },
      { text: "Mentored junior developers via code reviews and system design guidance, improving overall code quality and PR cycle time", metric: null }
    ]
  },
  {
    id: "exp-2",
    period: "09/2023 - 12/2023",
    role: "Senior Associate Engineer",
    company: "Zones LLC",
    location: "United States, Remote",
    bullets: [
      { text: "Built ReactJS features using reusable components and optimized API integration, improving page load time by", metric: "~20%" },
      { text: "Worked closely with backend teams to align API contracts and fix integration issues, reducing bugs by", metric: "~25%" },
      { text: "Improved release stability by introducing better testing and review practices", metric: null }
    ]
  },
  {
    id: "exp-3",
    period: "Earlier",
    role: "Associate Engineer",
    company: "Zones LLC",
    location: "United States, Remote",
    bullets: [
      { text: "Supported backend development using NodeJS, PostgreSQL, MySQL", metric: null },
      { text: "Improved API performance by", metric: "~15%" },
      { text: "Contributed to Docker + Kubernetes containerization for consistent environments", metric: null }
    ]
  },
  {
    id: "exp-4",
    period: "Earlier",
    role: "Backend Developer",
    company: "Bitnine Global Inc.",
    location: "Remote",
    bullets: [
      { text: "Built REST and GraphQL APIs", metric: null },
      { text: "Improved database query performance by", metric: "~20%" },
      { text: "Worked with cross-functional teams to deliver backend features", metric: null },
      { text: "Documented internal systems for onboarding and knowledge sharing", metric: null }
    ]
  },
  {
    id: "exp-5",
    period: "Earlier",
    role: "Junior Software Developer",
    company: "DevDen",
    location: "Remote",
    bullets: [
      { text: "Built web apps using Ruby on Rails with scalable architecture", metric: null },
      { text: "Developed hotel management system to streamline operations", metric: null }
    ]
  }
];

export const education = [
    {
    id: "edu-1",
    school: "University of Turku, Finland",
    degree: "MS Software Engineering",
    period: "Foundation",
    location: "Finland",
    description: "Advanced study of scalable systems, distributed architectures, and modern software engineering practices. Focused on building reliable, production-grade systems, with emphasis on system design, cloud-native development, and performance optimization."
  },
  {
    id: "edu-2",
    school: "FAST - National University of Computer and Emerging Sciences",
    degree: "BS Computer Science",
    period: "Foundation",
    location: "Pakistan",
    honors: "Dean's List",
    description: "Built a strong foundation in core computer science, including data structures, algorithms, databases, and operating systems. Developed problem-solving discipline and engineering fundamentals that underpin my approach to designing efficient and maintainable software."
  }
];

export const navLinks = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "experience", label: "Experience" },
  { id: "education", label: "Education" },
  { id: "contact", label: "Contact" }
];
